import { render } from "./Manage.vue?vue&type=template&id=78c6ea07"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=78c6ea07&lang=scss"
script.render = render

export default script